import React from 'react';
import { motion } from 'framer-motion';
const photos = [{
  src: 'https://cdn.magicpatterns.com/uploads/fMBTf6yXTDqQhz7YUoSzky/Be_Clinical_Interior_1.webp',
  alt: 'Be Clinical lounge with neon hexagon signs'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/hxiG57n9bPmHi8q5kZtP8W/Be_Clinical_Interior_2.webp',
  alt: 'Be Clinical waiting area with neon Be Magnificent signage'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/i6XcUhEmkGJkdux1woMVDW/Be_Clinical_Interior_3.webp',
  alt: 'Be Clinical reception desk with hexagon logo'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/sffh7UpX2Nz8UPrHZKzxJT/Be_Clinical_Patient_Room_1.webp',
  alt: 'Be Clinical treatment room with Be Fabulous neon'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/bw6Ex14gTvL4hF55bwuLkM/Be_Clinical_Patient_Room_2.webp',
  alt: 'Be Clinical product room with branded vending machine'
}];
export const ClinicGallery = () => {
  return <section className="w-full bg-be-navy py-16 sm:py-20 px-6 sm:px-10" data-id="element-106">
      <div className="max-w-6xl mx-auto" data-id="element-107">
        {/* Heading */}
        <div className="max-w-2xl mb-10 sm:mb-14" data-id="element-108">
          <div className="h-px bg-be-pink w-14 mb-5" data-id="element-109" />
          <p className="text-be-pink text-xs sm:text-sm font-semibold tracking-[0.3em] uppercase mb-4" data-id="element-110">
            Step Inside
          </p>
          <h2 className="text-white font-black uppercase leading-[1] tracking-tight text-4xl sm:text-5xl md:text-6xl mb-3" data-id="element-111">
            A space designed
          </h2>
          <h3 className="font-serif italic text-be-pink-light text-4xl sm:text-5xl md:text-6xl leading-none mb-6" data-id="element-112">
            to make you glow<span className="text-be-pink" data-id="element-113">.</span>
          </h3>
          <p className="text-white/70 text-base sm:text-lg leading-relaxed" data-id="element-114">
            Medical-grade tech, modern treatment rooms, and a vibe that feels
            more boutique than clinic. Come see why Bay Area patients keep
            coming back.
          </p>
        </div>

        {/* Asymmetric editorial grid */}
        <div className="grid grid-cols-12 gap-3 sm:gap-4 auto-rows-[140px] sm:auto-rows-[180px] md:auto-rows-[220px]" data-id="element-115">
          {/* Featured large — top left */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="col-span-12 sm:col-span-7 row-span-2 overflow-hidden group relative" data-id="element-116">
            <img src={photos[0].src} alt={photos[0].alt} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-117" />
          </motion.div>

          {/* Top right */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="col-span-6 sm:col-span-5 row-span-1 overflow-hidden group relative" data-id="element-118">
            <img src={photos[1].src} alt={photos[1].alt} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-119" />
          </motion.div>

          {/* Middle right */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="col-span-6 sm:col-span-5 row-span-1 overflow-hidden group relative" data-id="element-120">
            <img src={photos[2].src} alt={photos[2].alt} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-121" />
          </motion.div>

          {/* Bottom row — 2 images */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="col-span-6 row-span-1 overflow-hidden group relative" data-id="element-122">
            <img src={photos[3].src} alt={photos[3].alt} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-123" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} className="col-span-6 row-span-1 overflow-hidden group relative" data-id="element-124">
            <img src={photos[4].src} alt={photos[4].alt} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-125" />
          </motion.div>
        </div>
      </div>
    </section>;
};